import { Box, Typography, List, ListItem } from "@mui/material";
import React from "react";
import data from "../../Assets/data/opeds.json";
const OpEdsSection = React.forwardRef((props, ref) => {
  return (
    <>
      <Box ref={ref}>
        <Typography
          style={{ margin: "24px 0px 0px" }}
          fontSize="32px"
          fotnWeight={800}
        >
          Op - Eds
        </Typography>
        <List>
          {data.map((oped, i) => {
            return (
              <ListItem
                key={i}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                }}
              >
                <Typography fontWeight={600} fontSize="18px">
                  {oped.title}
                </Typography>
                <Typography>{oped.piece}</Typography>
                <Typography fontSize="14px">{oped.date}</Typography>
              </ListItem>
            );
          })}
        </List>
      </Box>
    </>
  );
});

export default OpEdsSection;
